const { HudlDataSchemas } = require('@hudl/analytics');

/**
 * Builds Condition Entities from a pathname and uiStructure.
 *
 * Process:
 *  - Match the static portion of the pathname against known UI structure paths
 *  - After matching static parts, map the remaining dynamic URL parts to urlParams
 *  - Create Condition Entities (one per param-value pair)
 *
 * Notes:
 *  - Only exact static parts are matched (e.g., "team/overview")
 *  - Dynamic segments (e.g., ":teams") are mapped after static parts
 *  - If no matching page or urlParams exist, returns an empty array
 */

export const buildConditionEntitiesFromUrl = (pathname, uiStructure) => {
  const urlParts = pathname.split('/').filter(Boolean); // Split pathname into parts, ignoring empty segments

  let matchingPage = null;
  let matchingPath = '';

  // Find the best matching static path in uiStructure
  uiStructure.pages.forEach((page) => {
    page.path.forEach((path) => {
      const staticParts = path.split('/').filter(Boolean);

      let matches = true;
      for (let i = 0; i < staticParts.length; i += 1) {
        if (urlParts[i] !== staticParts[i]) {
          matches = false; // Mismatch found — not a match
          break;
        }
      }

      // If matched, prefer the longer static match (more specific)
      if (
        matches &&
        (!matchingPath ||
          staticParts.length > matchingPath.split('/').filter(Boolean).length)
      ) {
        matchingPage = page;
        matchingPath = path;
      }
    });
  });

  // If no match or no dynamic parameters, skip
  if (!matchingPage || !matchingPage.urlParams) {
    return [];
  }

  const staticPartsCount = matchingPath.split('/').filter(Boolean).length;
  const dynamicParts = urlParts
    .slice(staticPartsCount)
    .filter((part) => /^\d+$/.test(part));

  const conditionEntities = [];

  // Map each urlParam to its corresponding dynamic part
  matchingPage.urlParams.forEach((param, index) => {
    const cleanParam = param.replace(':', '');
    const value = dynamicParts[index];

    if (value) {
      const entity = HudlDataSchemas.ConditionEntity.V2_0_0.describe({
        condition_type: cleanParam,
        condition_value: value,
        condition_subtype: null,
        condition_operator: '=',
        is_pre_selected: true,
      });
      conditionEntities.push(entity);
    }
  });

  return conditionEntities;
};
